var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "var(--icon-dark-gray)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.541 12.127c1.15 0 2.08.867 2.08 1.936 0 1.07-.93 1.937-2.08 1.937-1.149 0-2.08-.867-2.08-1.937s.931-1.936 2.08-1.936zm.591-11.12a5.74 5.74 0 013.548.998c.867.644 1.356 1.632 1.318 2.664a3.37 3.37 0 01-.542 1.916 7.537 7.537 0 01-2.057 1.816A6.279 6.279 0 009.081 9.49a1.612 1.612 0 00-.278.978v.61h-2.87v-.75a3.117 3.117 0 01.443-1.685A5.645 5.645 0 018 7.119a6.65 6.65 0 001.501-1.23c.24-.308.367-.679.364-1.059a1.12 1.12 0 00-.52-.998 2.621 2.621 0 00-1.457-.343 8.797 8.797 0 00-3.706.989L3 2.268a10.908 10.908 0 015.132-1.26z"
  })));
}
export default SvgQuestionMark;